import React, { ReactNode } from 'react';
import { useLocation, Navigate, Location } from 'react-router-dom';
import LoadingDialog from './LoadingDialog';
import useAuth from '../utils/useAuth';
import { getAuthSessionVersion } from '../utils/authQueryCache';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, appUser, loading, signOut } = useAuth();
  const location: Location = useLocation();

  const loadingMessages: string[] = [
    "Checking session...",
    "Verifying authentication...",
    "Almost there...",
  ];

  if (loading) {
    return <LoadingDialog messages={loadingMessages} title="Authenticating" />;
  }

  if (!user) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />
  }

  if (!appUser) {
    return (
      <div className="sky-auth-container">
        <div className="sky-auth-card">
          <h1 className="sky-auth-title">Sky-CRM Access Required</h1>
          <p style={{ color: 'var(--text-2)', fontSize: 13, lineHeight: 1.6, margin: '0 0 16px', textAlign: 'center' }}>
            Signed in as <strong>{user.email}</strong>, but this account is not linked to an active Sky-CRM user.
          </p>
          <button className="sky-btn sky-auth-submit" type="button" onClick={() => void signOut()}>
            Sign out
          </button>
        </div>
      </div>
    );
  }

  return <React.Fragment key={`${user.id}:${getAuthSessionVersion()}`}>{children}</React.Fragment>;
};

export default ProtectedRoute;
